import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPagination$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPagination extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '33b200488a95d35fb1e70c571b0e5aeebdef5ec4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9a4cbb0f1be646226d8034c01eac71c537cbd056', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f46776e16eb533aee2ea45bcc5f17c0f64b4e59b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.5 4.5A2.5 2.5 0 0 1 11 2a2.49 2.49 0 0 1 2.5 2.5 2.5 2.5 0 0 1-5 0m0 6.5A2.5 2.5 0 0 1 11 8.5a2.49 2.49 0 0 1 2.5 2.5 2.5 2.5 0 0 1-5 0m2.5 4a2.5 2.5 0 1 0 2.5 2.5A2.49 2.49 0 0 0 11 15m1.5-4A1.5 1.5 0 0 0 11 9.5 1.51 1.51 0 0 0 9.5 11a1.5 1.5 0 0 0 3 0M11 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5 14.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pagination", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pagination"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pagination":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPagination$1);
            }
            break;
    } });
}

const CosmosIconPagination = CosmosIconPagination$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPagination, defineCustomElement };
